import { Clock, PenLine, Sparkles, ShieldCheck } from 'lucide-react';
import { Chapter, FadeUp } from '../motion';
import { useT } from '../../i18n/LangContext';
import { useContent } from '../../data/useContent';

const ICONS = { Clock, PenLine, Sparkles, ShieldCheck };

export default function Promise() {
  const t = useT();
  const { PROMISES } = useContent();

  return (
    <section data-testid="promise-section" className="bg-white py-24 text-ink md:py-32">
      <div className="container-site">
        <Chapter n={3} label={t['ch.promise']} dark />
        <FadeUp>
          <h2 className="max-w-2xl font-serif text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">
            {t['pr.h2a']} <span className="italic text-gold-dim">{t['pr.h2b']}</span>
          </h2>
        </FadeUp>
        <div className="mt-14 grid gap-px overflow-hidden rounded-xl border border-black/10 bg-black/10 sm:grid-cols-2 lg:grid-cols-4">
          {PROMISES.map((p, i) => {
            const Icon = ICONS[p.icon];
            return (
              <FadeUp key={p.title} delay={i * 0.08} className="h-full">
                <div data-testid={`promise-${i}`} className="group h-full bg-white p-8 transition-colors duration-500 hover:bg-ink">
                  <Icon className="h-8 w-8 text-gold" />
                  <h3 className="mt-5 font-serif text-2xl font-semibold transition-colors duration-500 group-hover:text-white">{p.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-neutral-500 transition-colors duration-500 group-hover:text-silver">{p.line}</p>
                </div>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </section>
  );
}
